module.exports = __webpack_public_path__ + "static/media/meteringicon03@2x.6d56da68.png";